import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AbsBreadcrumbsComponent } from './abs-breadcrumbs.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [AbsBreadcrumbsComponent],
  exports: [AbsBreadcrumbsComponent],
})
export class AbsBreadcrumbsModule { }
